import auth from '@/Middlewares/auth.js'
import Route from '@/Setup/Routes/Route.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const permissionRoutes = new RouteGroup(() => {
  return [
    new Route('permissions.list', '/permissions/:tab?', () =>
      import(/* webpackChunkName: "admin" */ './Pages/List.vue')
    )
      .permission('permissions.view')
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
